/* eslint-disable import/no-anonymous-default-export */
export default {
    local:  {
        serviceHost: "https://localhost",
        identityHost: "https://localhost",
        clientId:"giving-portal"
    },
    dev: {
        serviceHost: "https://givingportal.dev.vfx.local/svc",
        identityHost: "https://givingportal.dev.vfx.local/svc",
        clientId: "giving-portal"
    },
    qa: {
        serviceHost: "https://givingportal.qa.vfx.local/svc",
        identityHost: "https://givingportal.qa.vfx.local/svc",
        clientId: "giving-portal"
    },
    sandbox: {
        serviceHost: "https://gateway2.vinformatix.com:1201/svc",
        identityHost: "https://gateway2.vinformatix.com:1201/svc",
        clientId: "giving-portal"
    },
    staging: {
        serviceHost: "https://givingportal.cauw.org:453/svc",
        identityHost: "https://givingportal.cauw.org:453/svc",
        clientId: "giving-portal"
    },
    prod: {
        serviceHost: "https://givingportal.cauw.org/svc",
        identityHost: "https://givingportal.cauw.org/svc",
        clientId: "giving-portal"
    }
};
